<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>{{ data.message }}</div>
<div mat-dialog-actions class="flex flex-row justify-between">
    <button mat-raised-button (click)="onRemove(0)">
        <mat-icon>{{ data?.actions?.cancel?.icon }}</mat-icon>
        {{ data?.actions?.cancel?.label }}
    </button>
    <button
        mat-raised-button
        cdkFocusInitial
        color="{{ data?.actions?.confirm?.color }}"
        (click)="onRemove(1)"
    >
        <mat-icon>{{ data?.actions?.confirm?.icon }}</mat-icon>
        {{ data?.actions?.confirm?.label }}
    </button>
</div>
